import React, { useEffect } from 'react'
import { Tabs, Tab, makeStyles, Button, Box, Paper } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { KeyboardArrowRight } from '@mui/icons-material'
import EventsListing from './events/EventListing'
import SubEventsListing from './sub-events/SubEventsListing'

const scheduleTabs = Object.freeze({
  EVENTS: 'events',
  SUB_EVENTS: 'sub-events'
})

const Schedule = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  // Get the search params from the URL
  const searchParams = new URLSearchParams(location.search)
  // Get tab from URL or default to 'events'
  const tab = searchParams.get('tab') || scheduleTabs.EVENTS

  // Ensure the tab param exists in URL when component mounts
  useEffect(() => {
    if (!searchParams.has('tab')) {
      const newSearchParams = new URLSearchParams(location.search)
      newSearchParams.set('tab', scheduleTabs.EVENTS)
      history.replace({
        pathname: location.pathname,
        search: newSearchParams.toString()
      })
    }
  }, [location.search, history, location.pathname, searchParams])

  // Update the URL when tab changes
  const handleTabChange = (_, newValue) => {
    const newSearchParams = new URLSearchParams(location.search)
    newSearchParams.set('tab', newValue)
    history.replace({
      pathname: location.pathname,
      search: newSearchParams.toString()
    })
  }

  const handleCreateEvent = () => {
    history.push(`${location.pathname}/events/new`)
  }

  const handleCreateSession = () => {
    history.push(`${location.pathname}/sub-events/new`)
  }

  return (
    <Box>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '10px'
        }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="off"
          aria-label="schedule tabs"
          className={classes.tabs}>
          <Tab label="Events" value={scheduleTabs.EVENTS} />
          <Tab label="Sub Events" value={scheduleTabs.SUB_EVENTS} />
        </Tabs>

        <Box className={classes.buttonGroupBox}>
          {tab === scheduleTabs.EVENTS ? (
            <Button
              variant="contained"
              color="primary"
              size="large"
              endIcon={<KeyboardArrowRight />}
              onClick={handleCreateEvent}>
              Create Event
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="large"
              endIcon={<KeyboardArrowRight />}
              onClick={handleCreateSession}>
              Create Sub Event
            </Button>
          )}
        </Box>
      </Box>

      <Box className={classes.contentWrapper}>
        <Paper variant="outlined" style={{ marginTop: '16px' }}>
          {tab === scheduleTabs.EVENTS && <EventsListing />}
          {tab === scheduleTabs.SUB_EVENTS && <SubEventsListing />}
        </Paper>
      </Box>
    </Box>
  )
}

export default Schedule

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontWeight: 600,
    paddingBottom: theme.spacing(1),
    fontSize: '26px'
  },
  tabsContainer: {
    borderRadius: 0,
    boxShadow: 'none',
    flexGrow: 1
  },
  tabs: {
    '& .MuiTab-root.MuiTab-labelIcon': {
      minHeight: '35px'
    },
    '& .MuiTab-root .MuiTab-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      alignItems: 'center'
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(51,220,235,0.16)'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.primary.main,
      height: '2px'
    }
  },
  actionBar: {
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    borderRadius: '8px',
    backgroundColor: '#f8f9fa',
    border: '1px solid #e0e0e0'
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '18px',
    color: '#2c3e50'
  },
  buttonGroupBox: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end'
  },
  contentWrapper: {
    marginTop: theme.spacing(2)
  }
}))
